export const HISTORY_COUNT = 15;
// export const WORD_LIMIT = 3000;
export const WORD_LIMIT = 4000;
export const SUMMARY_WORD_LIMIT = 6000;
export const CLASSIFY_WORD_LIMIT = 4000;
// export const DOC_UPLOAD_LIMIT = 5;
export const DOC_UPLOAD_LIMIT = 20;
export const LIMIT_APPID = ['1896878278857981952', '1897900108613419008', '1907439386263027712'];

export const SYS_COS_PREFIX = [
    'qidian-qbot-test-1251316161',
    'qidian-qbot-1251316161',
    'qbot-online-1251316161',
    'lke-realtime-test-1251316161'
];
export const mimeToExtension = {
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'image/bmp': 'bmp',
    'image/webp': 'webp',
    'image/svg+xml': 'svg'
};

// protocol url config
export const WORKFLOW_NODE_STATUS = {
    // 新工作流节点run_node下每个节点的状态
    // LOADING: 'loading',
    // ERROR: 'error',
    // SUCCESS: 'success',
    LOADING: 1,
    ERROR: 3,
    SUCCESS: 2
};

export const ELLIPS_LIMIT = 1000;

export const TOKENS_STATUS = {
    success: 'success',
    error: 'failed',
    pending: 'processing'
};
export const THOUGHT_STATUS = {
    success: 'success',
    failed: 'failed',
    processing: 'processing',
    stop: 'stop'
};
export const PRIVATE_PROTOCOL = 'https://rule.tencent.com/rule/202404080003';
export const SERVICE_PROTOCOL = 'https://cloud.tencent.com/document/product/301/104939';

// 其中 “腾讯云智能体开发平台平台”这几个字，为可点击跳转的超链接：
// 1. pc端跳转到产品登录页: https://lke.cloud.tencent.com/lke/#/trialProduct
// 2.手机端跳转到产品介绍页:https://cloud.tencent.com/product/lke(因为手机端不好创建应用)
export const LLM_PLATFORM_PC = 'https://lke.cloud.tencent.com/lke/#/trialProduct';
export const LLM_PLATFORM_MOBILE = 'https://cloud.tencent.com/product/lke';

export const TDOCURLPREFIX = 'https://lke.cloud.tencent.com'; // 腾讯文档 只有一个环境
export const ACCEPTDOCTYPE = 'doc,pdf,sheet,slide';
export const DOC_TYPE_MAP = {
    doc: 'doc',
    pdf: 'pdf',
    sheet: 'xlsx',
    slide: 'ppt'
};

export const PHONE_NUM_REGEX = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
export const TIME_COUNT = 60;
export const SENTENCECHAR = { '：': 1, '；': 1, '。': 1, '！': 1, '？': 1, '，': 1, ';': 1, '?': 1, '!': 1, ',': 1 };

export const ChatUserCategory = {
    TENCENT_CLOUD: 'cloud',
    PHONE_NUMBER: 'phone'
};



// WEBPACK FOOTER //
// ./src/constants/common.js